import intl from 'react-intl-universal';

export const REFUND_STATUS_MAP = {
  1: intl.get('bill_refound_res_success'),
  2: intl.get('bill_refound_res_hand_sign_success_two'),
  3: intl.get('bill_refound_res_fail'),
};

export const REFUND_OPERATE_CONTENT_MAP = {
  0: intl.get('reports_bill_enum_send_refund'),
  1: intl.get('reports_bill_enum_retry_refund'),
  2: intl.get('reports_bill_enum_manual_mark_success'),
};
